import Button from "./index";

// Standard submit button for modals/forms : flips to DISABLED + "Confirmation..." while loading.
const SubmitButton = ({
  loading = false,
  disabled = false,
  onClick,
  children = "Confirmer",
  size = "LG",
  loadingLabel = "Confirmation...",
}) => (
  <Button
    color={loading || disabled ? "DISABLED" : "PRIMARY"}
    size={size}
    onClick={loading || disabled ? undefined : onClick}
    disabled={loading || disabled}
  >
    {loading ? loadingLabel : children}
  </Button>
);

export default SubmitButton;
